import {IReportsFiltersRepository, TFilterRequestParams} from "../../domain/repositories/reports-filters-repository";
import {IHttpClient} from "../protocols/http";

export class ReportsFiltersDatasource implements IReportsFiltersRepository {
  constructor(
    private httpClient: IHttpClient,
    private baseUrl: string = process.env.REACT_APP_API_URL || ""
  ) {}

  async getRanges() {
    return this.httpClient
      .request({
        method: "GET",
        baseUrl: this.baseUrl,
        url: "/v1/InsightsParameters/ranges",
      })
      .then(({ body }) => body.data);
  }

  async getDevices() {
    return this.httpClient
      .request({
        method: "GET",
        baseUrl: this.baseUrl,
        url: "/v1/InsightsParameters/devices",
      })
      .then(({ body }) => body.data);
  }

  async getCampaigns(portfolioId: string | number) {
    return this.httpClient
      .request({
        method: "GET",
        baseUrl: this.baseUrl,
        url: `/v1/InsightsParameters/portfolio/${portfolioId}/campaign`,
      })
      .then(({ body }) => body.data);
  }

  async getCreatives(campaignId: string | number) {
    return this.httpClient
      .request({
        method: "GET",
        baseUrl: this.baseUrl,
        url: `/v1/InsightsParameters/campaign/${campaignId}/creative`,
      })
      .then(({ body }) => body.data);
  }

  async getUrls(creativeId: string | number) {
    return this.httpClient
      .request({
        method: "GET",
        baseUrl: this.baseUrl,
        url: `/v1/InsightsParameters/creative/${creativeId}/url`,
      })
      .then(({ body }) => body.data);
  }

  async getPortfolios() {
    return this.httpClient
      .request({
        method: "GET",
        baseUrl: this.baseUrl,
        url: `/v1/InsightsParameters/portfolio`,
      })
      .then(({ body }) => body.data);
  }

  async getInsightsParameters(params: TFilterRequestParams): Promise<any> {
    return this.httpClient
      .request({
        method: "GET",
        baseUrl: this.baseUrl,
        url: "/v1/InsightsParameters",
        params,
      })
      .then(({ body }) => body.data);
  }
}